import styled, { css } from 'styled-components';

import Tooltip from '../../Tooltip';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
interface Props{
  isFocused?: boolean;
  isFilled?: boolean;
  isErrored?: boolean;
}
export const Container = styled.div<Props>`
  background: var(--color-white);
  border-radius: 4px;
  padding: 16px;
  width: 100%;

  border: 1px solid var(--color-border);
  color: var(--color-gray);

  svg{
    flex-shrink: 0;
  }

  ${(props) => props.isErrored && css`
    border-color: var(--color-red);
  `}

  ${(props) => props.isFocused && css`
    border-color: var(--color-grey);
  `}

  display: flex;
  align-items: center;

  & + div{
      margin-top: 12px;
    }

  input{
    flex: 1;
    background: transparent;
    border: 0;
    color: var(--color-black);
    padding-left: 24px;

    &::placeholder{
      color: #666360;
    }
  }

  span{
      font-size: 14px;
      color: var(--color-red);
      text-align: left;
      /* display: none; */
    }

 position: relative;
`;

export const Error = styled(Tooltip)`
  position: absolute;
  right: 16px;

  height: 20px;
  margin-left: 16px;
  svg{
    margin: 0;
  }

  span {
    background: var(--color-red);
    color: #FFF;

    left: 90%;
    transform: translateX(-95%);

    &::before{
      border-color: var(--color-red) transparent;
      left: 90%;
    }
  }
`;
